import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Mail, Phone, Calendar, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminContactSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSubmissions();
  }, []);

  const fetchSubmissions = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/contact/submissions`);
      setSubmissions(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching submissions:', err);
      setError('Failed to load submissions. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="admin-container">
        <div className="admin-loading">Loading submissions...</div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <div className="admin-header">
        <button onClick={() => navigate('/')} className="btn-back">
          <ArrowLeft size={20} />
          Back to Home
        </button>
        <h1 className="admin-title">Contact Form Submissions</h1>
        <p className="admin-subtitle">Total Inquiries: {submissions.length}</p>
      </div>

      {error && (
        <div className="admin-error">
          {error}
          <button onClick={fetchSubmissions} className="btn-retry">Retry</button>
        </div>
      )}

      {submissions.length === 0 ? (
        <div className="admin-empty">
          <p>No contact submissions yet.</p>
        </div>
      ) : (
        <div className="admin-grid">
          {submissions.map((submission) => (
            <div key={submission.id} className="submission-card">
              <div className="submission-header">
                <span className={`submission-status status-${submission.status}`}>
                  {submission.status}
                </span>
                <span className="submission-date">
                  <Calendar size={16} />
                  {formatDate(submission.timestamp)}
                </span>
              </div>

              <div className="submission-body">
                <h3 className="submission-name">{submission.name}</h3>
                
                <div className="submission-contact">
                  <div className="contact-detail">
                    <Mail size={16} />
                    <a href={`mailto:${submission.email}`}>{submission.email}</a>
                  </div>
                  {submission.phone && (
                    <div className="contact-detail">
                      <Phone size={16} />
                      <a href={`tel:${submission.phone}`}>{submission.phone}</a>
                    </div>
                  )}
                </div>

                {submission.role && (
                  <div className="submission-service">
                    <strong>Role:</strong> {submission.role.charAt(0).toUpperCase() + submission.role.slice(1)}
                  </div>
                )}

                {submission.service && (
                  <div className="submission-service">
                    <strong>Service Interest:</strong> {submission.service}
                  </div>
                )}

                <div className="submission-message">
                  <strong>Message:</strong>
                  <p>{submission.message}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
